import { stringCompare } from '../utils/trainUtils';

export const Berths = Object.freeze({
  UPPER_BERTH: {
    key: 'UB',
    value: 'Upper',
  },
  LOWER_BERTH: {
    key: 'LB',
    value: 'Lower',
  },
  SIDE_LOWER: {
    key: 'SL',
    value: 'Side Lower',
  },
  SIDE_UPPER: {
    key: 'SU',
    value: 'Side Upper',
  },
  MIDDLE_BERTH: {
    key: 'MB',
    value: 'Middle',
  },
  WINDOW_SEAT: {
    key: 'WS',
    value: 'Window',
  },
  SIDE_MIDDLE: {
    key: 'SM',
    value: 'Side Middle',
  },
  CABIN: {
    key: 'CB',
    value: 'Cabin',
  },
  COUPE: {
    key: 'CP',
    value: 'Coupe',
  },
  NO_BERTH: {
    key: '',
    value: 'No Berth Preference',
  },
});

export const isEqualsBerth = (berth1, berth2) => stringCompare(berth1.key, berth2.key);

export const getBerthPreferenceOptions = () => Object.values(Berths).map((berth) => ({
  id: berth.key,
  text: berth.value,
  obj: berth,
}));

export const getBerthType = (value) =>
  getBerthPreferenceOptions().find((berth) => berth.id === value);

export const getBerthTypes = (values) =>
  getBerthPreferenceOptions().filter((berth) => values.includes(berth.id));
